import defaultState from "./state";
import { setNombreEtapa, filtroPrevencionista } from "./functions";

const planMovilidadReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOAD_ETAPA_PLANMOVILIDAD":
      return {
        ...state,
        etapaTabs: action.etapaTabs,
        etapaPosition: action.estadoProceso,
        etapaTitle: setNombreEtapa(action.estadoProceso),
        ultimoEstadoProceso: action.estadoProceso + 1,
      };

    case "CHANGE_ETAPA_PLANMOVILIDAD":
      return {
        ...state,
        etapaTitle: setNombreEtapa(action.newEtapaPosition),
        etapaPosition: action.newEtapaPosition,
      };

    case "LOAD_SUBMENU_PLANMOVILIDAD":
      return {
        ...state,
        subMenuPosition: 0,
        subMenuTabs: action.subMenuTabs,
      };

    case "CHANGE_SUBMENU_PLANMOVILIDAD":
      return {
        ...state,
        subMenuPosition: action.newSubMenuPosition,
      };

    case "LOADING_PLANMOVILIDAD":
      return {
        ...state,
        isLoading: action.isLoading,
      };

    case "HANDLER_SUBMEDIDAS_LOADING":
      return {
        ...state,
        isSubMedidasLoading: action.isSubMedidasLoading,
      };

    case "HANDLER_MEDIDAS_LOADING":
      return {
        ...state,
        isMedidasLoading: action.isMedidasLoading,
      };

    case "LOAD_INICIOMENU_PLANMOVILIDAD":
      return {
        ...state,
        inicioMenuPosition: 0,
        inicioMenuTabs: action.inicioMenuTabs,
      }

    case "CHANGE_INICIOMENU_PLANMOVILIDAD":
      return {
        ...state,
        inicioMenuPosition: action.inicioMenuPosition,
      }


    case "HANDLER_OBTENER_DOCUMENTO":
      return {
        ...state,
        isLoadingDocumento: action.isLoadingDocumento,
      };

    case "HANDLER_ESTADISTICAS_PLAN_MOVILIDAD":
      return {
        ...state,
        porcentajeAvance: action.result.estadisticaPlanes.porcentajeAvance,
        totalPlanesEjecucion: action.result.estadisticaPlanes.totalPlanesEjecucion,
      };

    case "HANDLER_LISTADO_PLANES_MOVILIDAD":
    case "CREAR_PLAN_MOVILIDAD":
        return {
          ...state,
          estadoEjecucion: action.result.planMovilidad.estadoEjecucion,
          estadoPlan: action.result.planMovilidad.estadoPlan,
          estadoProceso: action.result.planMovilidad.estadoProceso,
          ultimoEstadoProceso: action.result.planMovilidad.estadoProceso,
          idplanMovilidad: action.result.planMovilidad.idplanMovilidad,
          idtokenEncuesta: action.result.planMovilidad.idtokenEncuesta,
          habilitarTokenEncuesta: action.result.planMovilidad.habilitarTokenEncuesta,
          estadoTokenEncuesta: action.result.planMovilidad.estadoTokenEncuesta,
          estadoEncuestaCentro: action.result.planMovilidad.estadoEncuestaCentro,
          encuestaHombres: action.result.planMovilidad.encuestaHombres,
          encuestaMujeres: action.result.planMovilidad.encuestaMujeres,
          cantidadHombresCentro: action.result.planMovilidad.cantidadHombresCentro,
          cantidadMujeresCentro: action.result.planMovilidad.cantidadMujeresCentro,
          fechaCierreEncuestaTrabajador: action.result.planMovilidad.fechaCierreEncuestaTrabajador,
          medidasGeneradas: action.result.planMovilidad.medidasGeneradas,
          planesMovilidad: action.result.planesMovilidad,
          fechaCreacion: action.result.planMovilidad.fechaCreacion,
          // información de usuario
          rutusuario: (action.result.planMovilidad.rutusuarioNavigation) ? action.result.planMovilidad.rutusuarioNavigation.rutusuario : action.result.planMovilidad.rutusuario,
          nombreusuario: (action.result.planMovilidad.rutusuarioNavigation) ? action.result.planMovilidad.rutusuarioNavigation.nombre : null,
          emailusuario: (action.result.planMovilidad.rutusuarioNavigation) ? action.result.planMovilidad.rutusuarioNavigation.Email : null,

          // manejo de menús internos...
          etapaPosition: action.result.planMovilidad.estadoProceso - 1,
          etapaTitle: setNombreEtapa(action.result.planMovilidad.estadoProceso - 1),
        };

    case "CHANGE_FLAG_CARGA_INICIAL_PLAN_MOVILIDAD":
      return {
        ...state,
        cargaInicial: action.flag,
      };

    case "HANDLER_EDITAR_ENCUESTA_PLAN_MOVILIDAD":
    case "HANDLER_EDITAR_PLAN_MOVILIDAD":
      return {
        ...state,
        estadoEjecucion: action.result.planMovilidad.estadoEjecucion,
        estadoPlan: action.result.planMovilidad.estadoPlan,
        estadoProceso: action.result.planMovilidad.estadoProceso,
        ultimoEstadoProceso: action.result.planMovilidad.estadoProceso,
        idplanMovilidad: action.result.planMovilidad.idplanMovilidad,
        idtokenEncuesta: action.result.planMovilidad.idtokenEncuesta,
        habilitarTokenEncuesta: action.result.planMovilidad.habilitarTokenEncuesta,
        estadoTokenEncuesta: action.result.planMovilidad.estadoTokenEncuesta,
        estadoEncuestaCentro: action.result.planMovilidad.estadoEncuestaCentro,
        encuestaHombres: action.result.planMovilidad.encuestaHombres,
        encuestaMujeres: action.result.planMovilidad.encuestaMujeres,
        cantidadHombresCentro: action.result.planMovilidad.cantidadHombresCentro,
        cantidadMujeresCentro: action.result.planMovilidad.cantidadMujeresCentro,
        fechaCierreEncuestaTrabajador: action.result.planMovilidad.fechaCierreEncuestaTrabajador,
        medidasGeneradas: action.result.planMovilidad.medidasGeneradas,
        fechaCreacion: action.result.planMovilidad.fechaCreacion,
        planesMovilidad: action.result.planesMovilidad,
        // información de usuario
        rutusuario: action.result.planMovilidad.rutusuarioNavigation.rutusuario,
        nombreusuario: action.result.planMovilidad.rutusuarioNavigation.nombre,
        emailusuario: action.result.planMovilidad.rutusuarioNavigation.Email,
      };

    case "HANDLER_LISTADO_SUBMEDIDAS_PLAN_MOVILIDAD":
      return {
        ...state,
        subMedidasPlanesMovilidad: action.subMedidasPlanesMovilidad.filter((sm) => sm.subMedidaElegida),
      };

    case "HANDLER_LISTADO_MEDIDAS_PLAN_MOVILIDAD":
      return {
        ...state,
        medidasPlanMovilidad: action.medidasPlanMovilidad,
      };

    case "HANDLER_LISTADO_TAREAS_PLAN_MOVILIDAD":
      return {
        ...state,
        tareasPlanMovilidad: action.tareasPlanMovilidad,
      };

    case "HANDLER_GENERACION_MEDIDAS":
      return {
        ...state,
        medidasGeneradas: action.medidasGeneradas,
      };

    case "HANDLER_TOKEN_ENCUESTA":
      return {
        ...state,
        habilitarTokenEncuesta: action.habilitarTokenEncuesta,
      };

    case "OPEN_CLOSE_MODAL_EDITAR_SUBMEDIDA":
      return {
        ...state,
        isOpenSubMedidaModal: action.isOpenSubMedidaModal,
        dataSubMedidaModal: action.dataSubMedidaModal,
      };

    case "OPEN_CLOSE_MODAL_TRABAJADORES":
      return {
        ...state,
        isOpenEncuestaModal: action.isOpenEncuestaModal,
        dataEncuestaModal: action.dataEncuestaModal,
      };

    case "LOADING_MODAL_EDITAR_SUBMEDIDA":
      return {
        ...state,
        isLoadingSubMedidaModal: action.isLoadingSubMedidaModal,
      };

    case "HANDLER_PLAN_LISTADO_SUB_MEDIDAS":
      let medidas = state.medidasPlanMovilidad;
      let newMedida = null;
      // debería almacenar la metainformación de la medida, entonces tengo que recorrer las medidas:
      for (let i = 0; i < medidas.length; i++) {
        if (medidas[i].idplanMedida === action.idPlanMovilidadMedida) {
          newMedida = medidas[i];
          break;
        }
      }
      if (!newMedida) {
        return { ...state };
      }
      // elimino la medida completa... action.subMedidasPlanesMovilidad
      medidas = medidas.filter((medida) => medida.idplanMedida !== action.idPlanMovilidadMedida);
      // actualizo el campo de tblPlanSubMedida de la medida
      newMedida = {
        ...newMedida,
        tblPlanSubMedida: action.subMedidasPlanesMovilidad,
      };
      // ahora debo agregar la nueva medida obtenida
      medidas = medidas.concat([newMedida]);
      // debería ordenarlas por código...
      medidas = medidas.sort((a, b) => {
        if (a.codigo < b.codigo) return -1;
        if (a.codigo > b.codigo) return 1;
        return 0;
      });

      return {
        ...state,
        medidasPlanMovilidad: medidas,
      };

    case "LIMPIAR_PLAN_MOVILIDAD":
      return {
        ...state,
        estadoEjecucion: 0,
        estadoPlan: 0,
        estadoProceso: 0,
        ultimoEstadoProceso: 0,
        idplanMovilidad: null,
        idtokenEncuesta: null,
        habilitarTokenEncuesta: null,
        estadoTokenEncuesta: null,
        estadoEncuestaCentro: null,
        encuestaHombres: null,
        encuestaMujeres: null,
        cantidadHombresCentro: null,
        cantidadMujeresCentro: null,
        fechaCierreEncuestaTrabajador: null,
        medidasGeneradas: [],
        planesMovilidad: [],
        rutusuario: null,
        nombreusuario: null,
        emailusuario: null,
        //listaContenidos: [],
        subMedidasPlanesMovilidad: [],
        listadoSiniestros: [],
        esEncargado: false,
        fechaCreacion: null,
      };

    case "ON_ALERTA_PLAN_MOVILIDAD":
      return {
        ...state,
        alertaCode: action.alertaCode,
        alertaMensaje: action.alertaMensaje,
        alertaCall: true,
      };

    case "OFF_ALERTA_PLAN_MOVILIDAD":
      return {
        ...state,
        alertaCode: null,
        alertaMensaje: null,
        alertaCall: false,
      };

    case "HANDLER_CONTENIDOS_PLAN_MOVILIDAD":
      return {
        ...state,
        listaContenidos: action.listaContenidos,
      };

    case "HANDLER_ACCIDENTES_PLAN_MOVILIDAD":
      return {
        ...state,
        listadoSiniestros: action.listadoSiniestros,
      };

    case "HANDLER_LOADING_SINIESTROS":
      return {
        ...state,
        isLoadingSiniestros: action.isLoadingSiniestros,
      };

    case "GET_ENCARGADO_PLAN_MOVILIDAD":
      let esEncargado = false;
      if ( action.rutusuario && action.result.planMovilidad.rutusuarioNavigation ){
        if ( action.rutusuario === action.result.planMovilidad.rutusuarioNavigation.rutusuario ){
          esEncargado = true;
        }
      }
      return {
        ...state,
        esEncargado: esEncargado,
      }

    case "CHANGE_ENCARGADO_PLAN_MOVILIDAD":
      return {
        ...state,
        esEncargado: action.esEncargado,
      }

    case "SET_EMPLOYEES_PLANMOVILIDAD":
      return {
        ...state,
        employees: filtroPrevencionista(action.employees),
        isEmployeesLoaded : true,
      }

    default:
      return state;
  }
};

export default planMovilidadReducer;
